import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BalanceSheetComponent } from './financial/balance-sheet/balance-sheet.component';
import { SharedModule } from '../common/shared.module';
import { ConsolidatedIncomeStatementComponent } from './financial/consolidated-income-statement/consolidated-income-statement.component';
import { MarginReportComponent } from './financial/margin-report/margin-report.component';
import { TrialBalanceComponent } from './financial/trial-balance/trial-balance.component';
import { TransactionDetailComponent } from './transaction-reports/transaction-detail/transaction-detail.component';
import { IncomeStatementComponent } from './financial/income-statement/income-statement.component';
import { InvoicesComponent } from './transaction-reports/invoices/invoices.component';
import { PaymentsComponent } from './transaction-reports/payments/payments.component';
import { StatementsComponent } from './transaction-reports/statements/statements.component';
import { TaxComponent } from './transaction-reports/tax/tax.component';
import { AgingComponent } from './transaction-reports/aging/aging.component';
import {StripeTransactionDetailComponent} from './transaction-reports/stripe-transaction-detail/stripe-transaction-detail.component';
import {CheckRegisterComponent} from './transaction-reports/check-register/check-register.component';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { BalanceReportComponent } from './inventory/reports/balance-report/balance-report.component';
import { AssemblyReportComponent } from './inventory/reports/assembly-report/assembly-report.component';
import { TransferReportComponent } from './inventory/reports/transfer-report/transfer-report.component';
import { CountReportComponent } from './inventory/reports/count-report/count-report.component';
import { EntityReconciliationComponent } from './entity/entity-reconciliation/entity-reconciliation.component';

import { CashFlowComponent } from './financial/cash-flow/cash-flow.component';

// Payroll - Report
import { EmployeeDetailReportComponent } from './payroll/reports/employee-detail-report/employee-detail-report.component';
// Project Reports
import {ProjectStatusReportComponent} from './projects/project-status-report/project-status-report.component';
// CRM Reports
import {CrmPipelineReportComponent} from './crm/crm-pipeline-report/crm-pipeline-report.component';
import {CrmWonLostReportComponent} from './crm/crm-won-lost-report/crm-won-lost-report.component';
import {CrmActivityReportComponent} from './crm/crm-activity-report/crm-activity-report.component';
import {JournalEntryReportComponent} from './ledger/journal-entry-report/journal-entry-report.component';
import {CrmOpportunityDetailReportComponent} from './crm/crm-opportunity-detail-report/crm-opportunity-detail-report.component';
import {CrmFollowUpReportComponent} from './crm/crm-followup-report/crm-followup-report.component';
import {CrmPipelineAgingReportComponent} from './crm/crm-pipeline-aging-report/crm-pipeline-aging-report.component';
import {OverBudgetTasksReportComponent} from './projects/over-budget-tasks-report/over-budget-tasks-report.component';
import {ProjectDetailReportComponent} from './projects/project-detail-report/project-detail-report.component';
import {ProjectTimeReportComponent} from './projects/project-time-report/project-time-report.component';
import {ProjectProfitabilityReportComponent} from './projects/project-profitability-report/project-profitability-report.component';
import {ProjectMilestoneReportComponent} from './projects/project-milestone-report/project-milestone-report.component';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '../../app-routing.module';
import { AuditTrailComponent } from '../common/audit-trail/audit-trail.component';


// common components
import { CompanySelectComponent } from './report-resources/company-select/company-select.component';
import { FromToDateSelectComponent } from './report-resources/from-to-date-select/from-to-date-select.component';
import {AsOfDateSelectComponent} from './report-resources/as-of-date-select/as-of-date-select.component';
import { ReportTableHeaderComponent } from './report-resources/report-table-header/report-table-header.component';
import { LocationSelectComponent } from './report-resources/location-select/location-select.component';
import { LocationGroupSelectComponent } from './report-resources/location-group-select/location-group-select.component';
import { CurrencySelectComponent } from './report-resources/currency-select/currency-select.component';
import { ReportingFieldSelectComponent } from './report-resources/reporting-field-select/reporting-field-select.component';
import { AccountSelectComponent } from './report-resources/account-select/account-select.component';
import { AccountSubtotalSelectComponent } from './report-resources/account-subtotal-select/account-subtotal-select.component';
import { SubtotalParentSelectComponent } from './report-resources/subtotal-parent-select/subtotal-parent-select.component';
import { AccountTypeSelectComponent } from './report-resources/account-type-select/account-type-select.component';
import { ItemSelectComponent } from './report-resources/item-select/item-select.component';
import { EntitySelectComponent } from './report-resources/entity-select/entity-select.component';
import { EntityTypeSelectComponent } from './report-resources/entity-type-select/entity-type-select.component';
import { EntityCitySelectComponent } from './report-resources/entity-city-select/entity-city-select.component';
import { EntityStateSelectComponent } from './report-resources/entity-state-select/entity-state-select.component';
import { BankSelectComponent } from './report-resources/bank-select/bank-select.component';
import { PaymentSelectComponent } from './report-resources/payment-select/payment-select.component';
import { BatchSelectComponent } from './report-resources/batch-select/batch-select.component';
import { EntitySelectModalComponent } from './report-resources/entity-select-modal/entity-select-modal.component';
import { EntitySelectOnlyComponent } from './report-resources/entity-select-only/entity-select-only.component';
import { InvoiceSelectComponent } from './report-resources/invoice-select/invoice-select.component';
import { MarginSelectComponent } from './report-resources/margin-select/margin-select.component';
import { ModelSelectItemComponent } from './report-resources/model-select-item/model-select-item.component';
import { OrderSelectComponent } from './report-resources/order-select/order-select.component';
import { ReportTableHeaderV2Component } from './report-resources/report-table-header-v2/report-table-header-v2.component';
import { TaxSelectComponent } from './report-resources/tax-select/tax-select.component';
import {ReportHeaderButtonsComponent} from './report-resources/report-header-buttons/report-header-buttons.component';
import { PaymentTypeSelectComponent } from './report-resources/payment-type-select/payment-type-select.component';
import { EntityHistoryReportComponent } from './entity/entity-history-report/entity-history-report.component';
import { ModalItemHistoryComponent } from './report-resources/modal-item-history/modal-item-history.component';
import { WorkorderReportComponent } from './activity/reports/workorder-report/workorder-report.component';
import { AdminModule } from '../admin/admin.module';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import {WidgetModule} from '../common/widget/widget.module';
import {
  ReportDatepickerAdapter,
  ReportDatepickerFormatService,
  ReportDatepickerParserFormatter,
} from '../common/ngb-datepicker/ngb-datepicker-adapter';
// fixed assets reports
import {AssetRegisterComponent} from './fixed-assets/asset-register/asset-register.component';
import {DepreciationScheduleReportComponent} from './fixed-assets/depreciation-schedule/depreciation-schedule.component';
import {DisposalsReportComponent} from './fixed-assets/disposals/disposals.component';
import {FixedAssetGlEntriesComponent} from './fixed-assets/gl-entries/gl-entries.component';

// removed unused fixed-asset detail report + header component


@NgModule({
  declarations: [
    BalanceSheetComponent,
    ConsolidatedIncomeStatementComponent,
    MarginReportComponent,
    TrialBalanceComponent,
    TransactionDetailComponent,
    IncomeStatementComponent,
    BalanceReportComponent,
    AssemblyReportComponent,
    TransferReportComponent,
    CountReportComponent,
    InvoicesComponent,
    PaymentsComponent,
    StatementsComponent,
    TaxComponent,
    AgingComponent,
    StripeTransactionDetailComponent,
    CheckRegisterComponent,
    EntityReconciliationComponent,
    CashFlowComponent,
    // payroll
    EmployeeDetailReportComponent,
    // project reports
    ProjectStatusReportComponent,
    OverBudgetTasksReportComponent,
    ProjectDetailReportComponent,
    ProjectTimeReportComponent,
    ProjectProfitabilityReportComponent,
    ProjectMilestoneReportComponent,
    // crm reports
    CrmPipelineReportComponent,
    CrmWonLostReportComponent,
    CrmActivityReportComponent,
    JournalEntryReportComponent,
    CrmOpportunityDetailReportComponent,
    CrmFollowUpReportComponent,
    CrmPipelineAgingReportComponent,
    // common components
    CompanySelectComponent,
    FromToDateSelectComponent,
    ReportTableHeaderComponent,
    LocationSelectComponent,
    LocationGroupSelectComponent,
    CurrencySelectComponent,
    ReportingFieldSelectComponent,
    AccountSelectComponent,
    AccountSubtotalSelectComponent,
    SubtotalParentSelectComponent,
    AccountTypeSelectComponent,
    ItemSelectComponent,
    EntitySelectComponent,
    EntityTypeSelectComponent,
    EntityCitySelectComponent,
    EntityStateSelectComponent,
    BankSelectComponent,
    PaymentSelectComponent,
    BatchSelectComponent,
    EntitySelectModalComponent,
    EntitySelectOnlyComponent,
    InvoiceSelectComponent,
    MarginSelectComponent,
    ModelSelectItemComponent,
    OrderSelectComponent,
    ReportTableHeaderV2Component,
    TaxSelectComponent,
    ReportHeaderButtonsComponent,
    PaymentTypeSelectComponent,
    EntityHistoryReportComponent,
    ModalItemHistoryComponent,
    WorkorderReportComponent,
    // new as-of control
    AsOfDateSelectComponent,
    // fixed assets
    AssetRegisterComponent,
    DepreciationScheduleReportComponent,
    DisposalsReportComponent,
    FixedAssetGlEntriesComponent,
  ],
  exports: [
    AuditTrailComponent,
    ReactiveFormsModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    CompanySelectComponent,
    FromToDateSelectComponent,
    AsOfDateSelectComponent,
    ReportTableHeaderComponent,
    LocationSelectComponent,
    LocationGroupSelectComponent,
    CurrencySelectComponent,
    ReportingFieldSelectComponent,
    AccountSelectComponent,
    AccountSubtotalSelectComponent,
    SubtotalParentSelectComponent,
    AccountTypeSelectComponent,
    ItemSelectComponent,
    EntitySelectComponent,
    EntityTypeSelectComponent,
    EntityCitySelectComponent,
    EntityStateSelectComponent,
    BankSelectComponent,
    PaymentSelectComponent,
    BatchSelectComponent,
    EntitySelectModalComponent,
    EntitySelectOnlyComponent,
    InvoiceSelectComponent,
    MarginSelectComponent,
    ModelSelectItemComponent,
    OrderSelectComponent,
    ReportTableHeaderV2Component,
    TaxSelectComponent,
    ReportHeaderButtonsComponent,
    PaymentTypeSelectComponent,
    ModalItemHistoryComponent,

  ], imports: [CommonModule,
    SharedModule,
    ReactiveFormsModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule, // required animations module
    FilterPipeModule,
    AdminModule,
    NgbDropdownModule,
    NgbDatepickerModule,
    NgbPaginationModule,
    WidgetModule,
    ScrollingModule],
  providers: [
    ReportDatepickerFormatService,
    {
      provide: NgbDateParserFormatter,
      useClass: ReportDatepickerParserFormatter,
    },
    {
      provide: NgbDateAdapter,
      useFactory: (formatter: NgbDateParserFormatter) => new ReportDatepickerAdapter(formatter),
      deps: [NgbDateParserFormatter],
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpClient(),
  ],
})
export class ReportsModule {}
